import { createTheme } from "@mui/material/styles";

import { colors, fontFamily, spacingUnit, typeScale } from "./tokens";

// Tema global MUI — identidade "Empório Machado" (Azul-Empório + Âmbar-Machado).
// Fase 1 aplica apenas o modo claro; a paleta dark já está tokenizada em
// `tokens.js` para quando um seletor de tema for introduzido em fase futura.
const palette = colors.light;

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: palette.primary.main,
      dark: palette.primary.dark,
    },
    secondary: {
      main: palette.secondary.main,
    },
    background: {
      default: palette.background.default,
      paper: palette.background.paper,
    },
    success: {
      main: palette.success.main,
    },
    error: {
      main: palette.error.main,
    },
    warning: {
      main: palette.warning.main,
    },
    text: {
      primary: palette.text.primary,
      secondary: palette.text.secondary,
    },
  },
  spacing: spacingUnit,
  typography: {
    fontFamily: fontFamily.body,
    h1: { fontFamily: fontFamily.display, fontSize: typeScale.h1, fontWeight: 700 },
    h2: { fontFamily: fontFamily.display, fontSize: typeScale.h2, fontWeight: 700 },
    h3: { fontFamily: fontFamily.display, fontSize: typeScale.h3, fontWeight: 600 },
    h4: { fontFamily: fontFamily.display, fontSize: typeScale.h4, fontWeight: 600 },
    body1: { fontFamily: fontFamily.body, fontSize: typeScale.body1 },
    body2: { fontFamily: fontFamily.body, fontSize: typeScale.body2 },
    caption: { fontFamily: fontFamily.body, fontSize: typeScale.caption },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: palette.background.default,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            outline: `2px solid ${palette.secondary.main}`,
            outlineOffset: 2,
          },
        },
      },
    },
  },
});

export default theme;
